import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { authApi } from 'src/api/auth';

import { ROUTE } from 'src/constants';

export const getTwitchOAuth = createAsyncThunk('auth/get-twitch-url', async () => {
  try {
    const response = await authApi.getTwitchOAuth();

    window.location.replace(response.data.url);

    return response.data;
  } catch (error) {
    console.error('getTwitchOAuth[error]', error.response.data);

    return toast(error.response.data.message, { type: 'error' });
  }
});

export const loginTwitchUser = createAsyncThunk(
  'auth/login-twitch-user',
  async (data, thunkApi) => {
    try {
      const response = await authApi.loginTwitchUser(data);

      localStorage.setItem('token', response.data.token);

      return response.data.user;
    } catch (error) {
      const { navigate } = data;

      navigate(ROUTE.MAIN);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const userLogin = createAsyncThunk('auth/user-login', async (data) => {
  try {
    const { email, password, navigate } = data;

    const response = await authApi.userLogin({ email, password });

    localStorage.setItem('token', response.data.token);

    if (navigate) {
      navigate(ROUTE.ADMIN.PROFILE);
    }

    return response.data;
  } catch (error) {
    console.error('userLogin[error]', error.response.data);
    return toast(error.response.data.message, { type: 'error' });
  }
});

export const validateToken = createAsyncThunk(
  'auth/validate-token',
  async (data = {}, thunkApi) => {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        return thunkApi.rejectWithValue('No authorization token provided');
      }

      const response = await authApi.validateUserToken();

      // console.log('response', response.data);

      return response.data;
    } catch (error) {
      const { navigate } = data;

      localStorage.removeItem('token');

      if (navigate) {
        navigate(ROUTE.MAIN);
      }

      console.error('validateToken[error]', error);

      const message = error?.response?.data?.message || 'Token validation failed';

      return thunkApi.rejectWithValue(message);
    }
  }
);
